const getCountryISO2 = require("country-iso-3-to-2");

export default class Transaction {

    constructor(jsonResponse) {
        this.transactionId = jsonResponse["transaction-id"];
        this.registrationId = jsonResponse["registration-id"];
        this.date = jsonResponse["date"];
        this.total = jsonResponse["total"];
        this.vat = jsonResponse["vat"];
        this.fees = jsonResponse["fees"];
        this.dollarAmount = jsonResponse["dollar-amount"];
        this.exchangeRate = jsonResponse["exchange-rate"];
        this.destinationAmount = jsonResponse["destination-amount"];
        this.destinationCurrency = jsonResponse["destination-currency"];
        this.destinationCountry = jsonResponse["destination-country"];
        this.status = jsonResponse["status"];
        this.remittancePartner = jsonResponse["remittance-partner"];
        this.remittanceBrandTransactionId = jsonResponse["remittance-brand-transaction-id"];
        this.remittanceBrandReferenceNumber = jsonResponse["remittance-brand-reference-number"];
        this.paymentReference = jsonResponse["payment-reference"];
        this.receiverReferenceNumber = jsonResponse["receiver-reference-number"];
        this.beneficiaryCountry = jsonResponse["beneficiary-country"];
        this.beneficiaryFirstName = jsonResponse["beneficiary-first-name"];
        this.beneficiaryLastName = jsonResponse["beneficiary-last-name"];
        this.customerFirstName = jsonResponse["customer-first-name"];
        this.customerLastName = jsonResponse["customer-last-name"];
        this.customerMsisdn = jsonResponse["customer-msisdn"];
        this.customerDateOfBirth = jsonResponse["customer-date-of-birth"];

        this.customerFullName = this.customerFirstName + " " + this.customerLastName;
        this.beneficiaryFullName = this.beneficiaryFirstName + " " + this.beneficiaryLastName;


        this.beneficiaryCountryISO2 =  getCountryISO2(this.beneficiaryCountry).toLowerCase()
    }

    static badgeColours = [
        {name: "CREATED", displayName: "Creates", shortName: "N", colour: "primary"},
        {name: "ON_HOLD_UNPAID", displayName: "Pending", shortName: "A", colour: "success"},
        {name: "APPROVED_UNPAID", displayName: "Unpaid", shortName: "D", colour: "danger"},
        {name: "APPROVED_PAID", displayName: "Paid", shortName: "P", colour: "success"},
        {name: "EXPIRED", displayName: "Expired", shortName: "S", colour: "warning"},
        {name: "COMPLETE", displayName: "Complete", shortName: "U", colour: "success"},
        {name: "CANCELED", displayName: "Cancelled", shortName: "U", colour: "info"},
        {name: "REJECTED", displayName: "Cancelled", shortName: "U", colour: "info"},
        {name: "REFUNDED", displayName: "Refunded", shortName: "U", colour: "info"},
        {name: "MARKED_FOR_REFUND", displayName: "Pending Refund", shortName: "U", colour: "info"},
        {name: "READY_FOR_REFUND", displayName: "Pending Refund", shortName: "U", colour: "info"},
        {name: "MARKED_FOR_CANCELLATION", displayName: "Pending Cancellation", shortName: "U", colour: "info"},
        {name: "READY_FOR_CANCELLATION", displayName: "Pending Cancellation", shortName: "U", colour: "info"},
        {name: "REMITTANCE_BRAND_ON_HOLD", displayName: "Pending", shortName: "U", colour: "info"}
    ];

}